module.exports = __webpack_public_path__ + "img/nuber_small.0373432b.svg";